module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ka-Lc.e73add44.png";